module.exports = __webpack_public_path__ + "img/monthly-tips.ec544a52.svg";